import type { ReactNode } from 'react'

import { twMerge } from 'tailwind-merge'

interface Props {
  rotulo: string
  valor: ReactNode
  bordaDireita?: boolean
  bordaInferior?: boolean
  className?: string
}

export function InfoItem({ rotulo, valor, bordaDireita, bordaInferior, className, ...props }: Readonly<Props>) {
  return (
    <div
      className={twMerge(
        'space-y-1',
        bordaDireita && 'border-r border-neutral-100',
        bordaInferior && 'border-b border-neutral-100',
        className,
      )}
      {...props}
    >
      <p className="text-sm font-medium text-neutral-600">{rotulo}</p>
      <p className="text-base text-neutral-800">{valor}</p>
    </div>
  )
}
